import localforage from 'localforage';

localforage.setDriver(localforage.LOCALSTORAGE);

const SUBDOMAIN_KEY = 'okta_subdomain';
const DOMAIN_KEY = 'okta_domain';

export default {
  getDomains() {
    return [
      {id: 'okta.com', name: 'okta.com'},
      {id: 'okta-emea.com', name: 'okta-emea.com'},
      {id: 'oktapreview.com', name: 'otkapreview.com'},
    ]
  },
  async getSavedDomain() {
    const subdomain = await localforage.getItem(SUBDOMAIN_KEY);
    const domain = await localforage.getItem(DOMAIN_KEY);
    return {
      subdomain: subdomain,
      domain: domain,
    };
  },
  async saveDomain(subdomain, domain) {
    await Promise.all([
      localforage.setItem(SUBDOMAIN_KEY, subdomain),
      localforage.setItem(DOMAIN_KEY, domain)
    ]);
  }
}
